export default __webpack_public_path__ + "static/media/CLOSED_SIDEBAR.01eef31e.svg";